import { render, staticRenderFns } from "./SellBills.vue?vue&type=template&id=b124d39a"
import script from "./SellBills.vue?vue&type=script&lang=js"
export * from "./SellBills.vue?vue&type=script&lang=js"
import style0 from "./SellBills.vue?vue&type=style&index=0&id=b124d39a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports